import { StoreState } from '../types';
import { PageId } from './types';

export const getGlobalIsLoading = (state: StoreState): boolean =>
  !!state.isLoading.global;
export const getIsLoading = (state: StoreState, pageId: PageId): boolean =>
  state.isLoading.pages.includes(pageId);
